<template>
  <b-container fluid class="ps-0">
    <b-row>
      <b-col lg="3" xl="2" xxl="2" md="3" sm="2" class="staticleftsidebar" v-if="windowWidth > 545">
        <LeftBar pagename="OutboundIssueDetails" masterheading="Outbound Issue" v-model="Id" :storestatus="true"
          :listed="sidebardata" :paramValues="ParamValues" :loading="loading" listtype="Issues">
        </LeftBar>
        <a class="back-btn" @click="goToFirstPage">
          <img alt="Vue logo" class="back" src="../../../../../../../assets/Img/icons/backtoright.svg" width="125"
            height="125" />
        </a>
      </b-col>
      <b-col lg="9" xl="10" xxl="10" md="9" sm="10">
        <b-container>
          <b-row>
            <b-col>
              <BacktoPage :goback="$router.back" class="my-5" v-if="windowWidth <= 545"></BacktoPage>
            </b-col>
            <b-col>
              <div class="d-flex align-items-center">
                <div class="main-header-store">MS</div>
                <div>
                  <p class="storecode">IS3874</p>
                  <p class="common-heading1">Dep</p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div v-if="windowWidth > 545">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty :createline="false" v-if="items.length === 0 && !loading"
                    eheader="OutBound Issue Details" econtent="OutBound Issue Details"
                    eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                  <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                    :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading1"
                    responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
                    :filters="filters">
                    <template v-slot:action="{ data }">
                      <span>
                        <EditIcon />
                        <DeleteIcon />
                      </span>
                    </template>
                  </Tableview>
                </div>
              </div>
              <div v-if="windowWidth <= 545">
                <MobileLoader v-if="loading" />
                <div v-if="!loading">
                  <MasterEmpty :createline="false" v-if="items.length === 0 && !loading"
                    eheader="OutBound Issue Details" econtent="OutBound Issue Details"
                    eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                  <MobileViewCardHeader v-else>
                    <template v-slot:mobilecard>
                      <div class="mobile-card" v-for="item in items">
                        <div class="d-flex align-items-center gap-1">
                          <p class="light-name">{{ item['RefMASNo'] }} /</p>
                          <p class="light-name">{{ item['ItemCode'] }} /</p>
                          <p class="light-name1">{{ item['HSNCode'] }}</p>
                        </div>
                        <p class="name">{{ item['Itemname1'] }}</p>
                        <div class="d-flex align-items-center gap-2" v-if="item['BatchNo']">
                          <p class="light-name">Batch :</p>
                          <p class="small-name">{{ item['BatchNo'] }}</p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <p class="light-name">Requested Quantity :</p>
                          <p class="small-name">{{ item['RequestedQty'] ? item['RequestedQty'] : '0' }}</p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <p class="light-name">Received Quantity :</p>
                          <p class="small-name">{{ item['RecievedQty'] ? item['RecievedQty'] : '0' }}</p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <p class="light-name">Returns :</p>
                          <p class="small-name">{{ item['ReturnsQty'] ? item['ReturnsQty'] : '0' }}</p>
                        </div>
                      </div>
                    </template>
                  </MobileViewCardHeader>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import { defineComponent, ref, computed, onMounted, watch, onUnmounted } from "vue";
import LeftBar from "../../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import POTableview from "../../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import QuotesTableview from "../../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingCreation from "../../../../../../../modules/Inventory/pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import service from "../../../../../../../modules/Inventory/Service/ManufacturerService";
import commonService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import WithoutStockService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import Service from "../../../../../../../modules/Inventory/Service/StockOutService";

import ManufacturerMasterTableview from "../../../../../../../modules/Inventory/pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterTableview.vue";
import ManufacturerDetailsVue from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ManufacturerItemMappingTable from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerItemMappingTable.vue";
import ManufacturerSupplierMappingTable from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerSupplierMappingTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from '../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue';
import SidebarList from "../../../../../../../components/SkeletonLoaderComponents/SidebarList.vue";
import { setupHistoryManagement } from "../../../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  components: {
    ItemStoreMappingCreation,
    QuotesTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    // Rightsidebar,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    GrnTable,
    storetab,
    ManufacturerMasterTableview,
    ManufacturerSupplierMappingTable,
    ManufacturerDetailsVue,
    ManufacturerItemMappingTable,
    Tableview,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    SidebarList,
    BacktoPage
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    // items: {
    //     type: Array,
    //     default: () => [],
    // },

    propsParams: {
      type: Object,
    },
  },
  setup() {
    const { t } = useI18n();
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      IsShow(), IsShowByStockOutId();
    });
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let items = ref([]);
    let loading1 = ref(false);
    let loading = ref(false);
    let sidebardata = ref([]);
    let Id = ref([]);
    const route = useRoute();
    let ToStoreName = ref("");
    let IssueId = ref("");

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    // const sidebardata = [
    //     {
    //         id: "SUP9856",
    //         // store: "MS",
    //         storename: "Maheshwari PVT Limited",
    //     },
    //     // {
    //     //     id: "SUP9856",
    //     //     store: "SS",
    //     //     storename: "MainStore Supplies",
    //     // },
    // ];
    const router = useRouter();
    const routerChangeCount = ref(0);

    onBeforeRouteUpdate(() => {
      routerChangeCount.value++;
    });
    const goToFirstPage = () => {
      // router.go(-routerChangeCount.value);
      // router.go(-1);
      // Go back to the very first page
      if (routerChangeCount.value == 0) {
        setupHistoryManagement(router, 2);
      } else {
        const i = routerChangeCount.value + 2;
        //alert("dfds" + i)
        setupHistoryManagement(router, i);
      }

    };
    //Table List
    const headers = [
      // {
      //   header: "Doc Type",
      //   field: "DocType",
      // },

      {
        header: t('storetabdetails.outboundissuedetails.Id'),
        field: "RefNo",
        class: "smallwidth",


      },
      {
        header: t('storetabdetails.outboundissuedetails.Code'),
        field: "ItemCode",
        class: "smallwidth",

      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t('storetabdetails.outboundissuedetails.Name'),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",

      },
      {
        header: t('storetabdetails.outboundissuedetails.Batch'),
        field: "BatchNo",
        class: "smallwidth",

      },
      {
        header: t('storetabdetails.outboundissuedetails.ReqQty'),
        field: "RequestedQty",
        class: "smallwidth",
        bodyclass: "right_td",


      },
      {
        header: t('storetabdetails.outboundissuedetails.ReceivedQty'),
        field: "RecievedQty",
        class: "smallwidth",
        bodyclass: "right_td",

      },
      //   {
      //     header: "Accepted Quantity",
      //     field: "",
      //   },
      {
        header: t('storetabdetails.outboundissuedetails.ReturnQty'),
        field: "ReturnsQty",
        class: "smallwidth",
        bodyclass: "right_td",

      },
      //   { field: "action", header: "Action", slot: "action",
      // frozencolumn: true, sortable: false },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const columnName = "StoreId";
        const columnValue = ParamValues.value.StoreId;
        let Condition = "sm.HospitalId=" + usersData.OrganizationId + "  and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))"

        let response = await Service.listStockOutMasterTM(
          '',
          '',
          '',
          '',
          "10,11",
          columnName,
          columnValue,
          '',
          '',
          '',
          '',
          '',
          '',
          "",
          "",
          1,
          '',
          Condition
        );
        sidebardata.value = response["result"].filter(
          (x) =>
            x.HospitalId == usersData.OrganizationId &&
            x.BranchId == usersData.BranchId
        );

        console.log(sidebardata.value);

        const oldKey1 = "ToStoreName";
        const newKey1 = "Name";
        const oldKey2 = "DocNo";
        const newKey2 = "Code";
        const oldKey3 = "StockOutTransId";
        const newKey3 = "Id";
        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
            [newKey3]: item[oldKey3],
          };
          delete newItem[oldKey1];
          delete newItem[oldKey2];
          delete newItem[oldKey3];
          return newItem;
        });
        loading.value = false;
        console.log(sidebardata.value);
      } catch (error) {
        console.log(error);
      }
    }
    // async function IsShow() {
    //     debugger;
    //     try {
    //         let response = await commonService.GetStockOutTMTableList(
    //             '10,11',
    //             ParamValues.value.StoreId,
    //             1
    //         );
    //         console.log(response["result"]);
    //         items.value = response["result"];
    //         console.log(items.value);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }
    debugger;
    const ParamValues = ref({
      Id: 0,
      StoreId: 0,
    });
    // let manufacturerId = route.query.id;
    // console.log(manufacturerId);
    ParamValues.value.Id = Number(route.query.id);
    ParamValues.value.StoreId = Number(route.query.storeid);
    console.log(ParamValues.value.Id);
    watch(
      () => route.query.id,
      (newVal: any) => {
        debugger;

        ParamValues.value.Id = Number(newVal);
        ParamValues.value.StoreId = Number(newVal);

        console.log(ParamValues.value.Id);

        IsShowByStockOutId();
      }
    );
    async function IsShowByStockOutId() {
      debugger;
      console.log(ParamValues.value.Id);
      const result = await WithoutStockService.GetItemsByIssueIdDocType(
        ParamValues.value.Id
      );
      console.log(result["result"]);
      items.value = result["result"];
      console.log(items.value);
      // ToStoreName.value = result["result"]
    }
    return {
      sidebardata,
      paramValue,
      IsShow,
      Id,
      loading1,
      loading,
      headers,
      globalFilterFields,
      filters,
      items,
      ParamValues,
      goToFirstPage,
      windowWidth,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}
</style>
